import React from "react";
import { Box, Grid2, Typography } from "@mui/material";
import CartLoader from "../../../Helper/Loaders/CartLoader";
import { useBaseEntityInfo } from "../../../Hooks/usePagesContent";
import UtilizationKPISection from "./UtilizationKPISection";
import StateOfUseBreakdownChart from "./StateOfUseBreakdownChart";
import StateOfUseTrendChart from "./StateOfUseTrendChart";
import StateOfUseTrendDetailsView from "./StateOfUseTrendDetailsView";

// ─── Main component ─────────────────────────────────────────────────────────────
const UtilisationTab = ({
  startDate,
  endDate,
  vehiclesConnected,
  isLoadingVehiclesCount,
  globalFilters = {},
  allOnboardingLocationsHierarchy,
  showTrendDetails,
  onShowTrendDetails,
  onHideTrendDetails,
}) => {
  const { baseEntityTypePluralLable } = useBaseEntityInfo();

  // ── Trend details drill-down view ────────────────────────────────────────────
  if (showTrendDetails) {
    return (
      <Box sx={{ width: "100%" }}>
        <StateOfUseTrendDetailsView
          onBack={onHideTrendDetails}
          startDate={startDate}
          endDate={endDate}
          allOnboardingLocationsHierarchy={allOnboardingLocationsHierarchy}
          initialHierarchicalLocation={globalFilters.hierarchicalLocation}
        />
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3, maxWidth: 'calc(100vw - 102px)' }}>

      {/* ── KPI Header ────────────────────────────────────────────────────── */}
      <Grid2 container alignItems="center" justifyContent="space-between">
        <Box>
          <Typography
            variant="fw400s20c000"
            sx={{ lineHeight: "28px", fontWeight: 300 }}
          >
            Key Performance Indicators
          </Typography>
        </Box>
        {isLoadingVehiclesCount ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              height: "16px",
              padding: "8px 16px",
            }}
          >
            <CartLoader />
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.5,
              padding: "8px 16px",
              borderRadius: "8px",
            }}
          >
            <Typography
              variant="fw400s16c000000"
              sx={{ color: "#444B51", lineHeight: "16px" }}
            >
              Connected {baseEntityTypePluralLable} Today :
            </Typography>
            <Typography
              variant="fw400s16c000000"
              sx={{ fontWeight: 600, color: "#2E2E2E", lineHeight: "16px" }}
            >
              {vehiclesConnected.toLocaleString()}
            </Typography>
          </Box>
        )}
      </Grid2>

      {/* ── KPI Section ───────────────────────────────────────────────────── */}
      <UtilizationKPISection
        vehiclesConnected={vehiclesConnected}
        showHeader={false}
      />

      {/* ── Utilisation Section ───────────────────────────────────────────── */}
      <Box>
        <Typography
          variant="fw400s20c000"
          sx={{ lineHeight: "28px", fontWeight: 300 }}
        >
          Utilisation
        </Typography>
      </Box>

      <StateOfUseBreakdownChart
        startDate={startDate}
        endDate={endDate}
        globalFilters={globalFilters}
      />

      <StateOfUseTrendChart
        startDate={startDate}
        endDate={endDate}
        onDetailsClick={onShowTrendDetails}
      />

    </Box>
  );
};

export default UtilisationTab;
